namespace Gamification.Gamification {
    export namespace ProdottiEsperienzeClassiService {
        export const baseUrl = 'Gamification/ProdottiEsperienzeClassi';

        export declare function Create(request: Serenity.SaveRequest<ProdottiEsperienzeClassiRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ProdottiEsperienzeClassiRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ProdottiEsperienzeClassiRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ProdottiEsperienzeClassiRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Gamification/ProdottiEsperienzeClassi/Create",
            Update = "Gamification/ProdottiEsperienzeClassi/Update",
            Delete = "Gamification/ProdottiEsperienzeClassi/Delete",
            Retrieve = "Gamification/ProdottiEsperienzeClassi/Retrieve",
            List = "Gamification/ProdottiEsperienzeClassi/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ProdottiEsperienzeClassiService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
